/**
 * The number a person sees on a record — a 6-digit public id (D-030, replacing
 * the 10-digit one of D-004), one shared sequence across every kind of record,
 * so a number finds exactly one thing. It is also the record's id in the API
 * and in addresses (`/jobs/100197`). 999,999 records is decades at Majik's
 * volume, and the field can widen later without renumbering.
 */
import { z } from 'zod'

export const recordIdSchema = z.string().regex(/^\d{6}$/, 'A record number is 6 digits.')
export type RecordId = z.infer<typeof recordIdSchema>

/** The next free number after every one already used — the in-memory stores' sequence. */
export function nextRecordId(used: Iterable<string>): string {
  let max = 99_999
  for (const id of used) max = Math.max(max, Number(id))
  return String(max + 1)
}
